module.exports = __webpack_public_path__ + "img/jht-icon-32.331d5b4e.png";